/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Orthopaedic_RehabInputs */

const en_service_type_orthopaedic_rehab = /** @type {(inputs: Service_Type_Orthopaedic_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orthopaedic and injury rehab`)
};

const pl_service_type_orthopaedic_rehab = /** @type {(inputs: Service_Type_Orthopaedic_RehabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rehabilitacja ortopedyczna i pourazowa`)
};

/**
* | output |
* | --- |
* | "Orthopaedic and injury rehab" |
*
* @param {Service_Type_Orthopaedic_RehabInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_orthopaedic_rehab = /** @type {((inputs?: Service_Type_Orthopaedic_RehabInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Orthopaedic_RehabInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_orthopaedic_rehab(inputs)
	return en_service_type_orthopaedic_rehab(inputs)
});